// extracted by mini-css-extract-plugin
export default {"confirm-modal-message":"ConfirmModal_confirm-modal-message__kqND+"};